import capitalize from "lodash/capitalize";

// Row styling shared with other lists of choices.
export const radioRowClassName =
  "flex w-full cursor-pointer items-center gap-4 rounded-lg border border-border bg-surface p-4 text-left text-ink transition-colors hover:bg-canvas focus-visible:border-ink focus-visible:bg-surface-muted focus-visible:shadow-[inset_0_0_0_1px_rgb(var(--ax-ink))] focus-visible:outline-none active:bg-surface-pressed";

const Radio = ({
  title,
  subtext,
  onClick,
  capitalizeText = true,
  boldText = true,
}) => {
  return (
    <button onClick={onClick} className={radioRowClassName}>
      <span className="flex min-w-0 flex-1 flex-col gap-0.5">
        <span className={`text-body-lg ${boldText ? "font-semibold" : ""}`}>
          {capitalizeText ? capitalize(title) : title}
        </span>
        {subtext && (
          <span className="text-body-lg text-ink-secondary">
            {subtext.toLowerCase()}
          </span>
        )}
      </span>
      <span
        aria-hidden
        className="flex size-5 shrink-0 items-center justify-center rounded-full border border-control bg-surface"
      />
    </button>
  );
};

export default Radio;
